export default function DateInputbox({
  disabled = false,
  title,
  titleClass = 'text-[#424242]',
  inputClass = 'bg-[#FDFDFD]',
  placeholder = 'dd/mm/yyyy',
  value,
  onChange,
}) {
  return (
    <div className="w-full space-y-1">
      <div
        className={`font-[poppins] text-xs ${titleClass} font-normal leading-[20px] tracking-[0%]`}
      >
        {title}
      </div>
      <input
        id="default-datepicker"
        type="date"
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, 10))}
        className={`w-full font-[poppins] text-sm placeholder-[#A4A7AE] text-[#414651] font-normal focus:outline-none focus:border-[#414651] border border-[#C2C2C2] ${inputClass} py-2 px-3 rounded-[10px]`}
        placeholder={placeholder}
      />
    </div>
  );
}
